import React, { useState } from "react";
import { motion } from "framer-motion";
// Font awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faChevronUp,
	faCog,
	faEllipsisH,
	faPowerOff,
	faUser,
} from "@fortawesome/free-solid-svg-icons";

import Account from "../Account/Account";
import useAccount from "../hooks/useAccount";
import useToken from "../hooks/useToken";
import UserImage from "components/User/Image/UserImage";
import { t } from "i18next";
import SwitchInput from "components/Inputs/Switch/SwitchInput";
import Storage from "classes/Storage/Storage";
import { CustomPageLink } from "components/Menu/components/PageLink/PageLink";
import Button from "components/Button/Button";
import { useMediaQuery } from "react-responsive";
import { getDeviceInfo } from "includes/pwa_helpers";
import { UAParser } from "ua-parser-js";
import genRequest from "includes/request";

function AccountsMenu(props) {
	const { token } = useToken();
	const { account } = useAccount();
	const storage = new Storage();
	const [CurAccount, setCurAccount] = useState(false);
	const [accountsOpen, setAccountsOpen] = useState(false);
	const { accountClick, handleRemove } = props;
	const { isReduced, setIsReduced } = props;
	const { device, browser } = getDeviceInfo(new UAParser());

	function handleClick(account) {
		setCurAccount(account);
		accountClick(account);
	}

	function newAccount() {
		setCurAccount("new_account");
		accountClick("new_account");
	}

	function getAccounts() {
		let accounts = [];
		try {
			const accounts_string = storage.getItem("Accounts");
			if (accounts_string?.length) {
				accounts = accounts_string;
				if (accounts)
					accounts = accounts.sort((a, b) => {
						let a_full = a.FirstName + " " + a.LastName;
						let b_full = b.FirstName + " " + b.LastName;
						if (a_full < b_full) return -1;
						return 1;
					});
			}
		} catch (e) {
			return accounts;
		}
		return accounts;
	}

	let accounts = props.accounts ? props.accounts : getAccounts();
	if (!accounts && !token) return false;

	function OnesignalLogout() {
		window.OneSignalDeferred.push(async function (OneSignal) {
			await OneSignal.logout();
		});
	}

	function sendLogLogout() {
		const hasLogout = sessionStorage.getItem("connectionLogout");
		if (!hasLogout) {
			const logRequest = {
				EmployesId: account.EmployesId,
				TypeOfRequest: 1,
				Request_URI: window.location.origin,
				Browser: `${browser?.name.toLowerCase()}_${browser?.version.toLowerCase()}`,
				Origin: device.isMobile ? 1 : 0,
			};
			genRequest("Stats/CreateUserRequest/", logRequest, "post");
			sessionStorage.setItem("connectionLogout", "true");
		}
	}

	function MultiAccount() {
		let theme = props.theme;
		let cur_theme = props.theme.theme;
		return (
			<div
				className={"accounts-menu"}
				// onMouseLeave={handleMouseLeave}
				onClick={(e) => e.stopPropagation()}
			>
				<div>
					<CurAccountElem
						OnesignalLogout={OnesignalLogout}
						user={account}
						isActive={true}
						// toggleMenu={toggleAccountsMenu}
						handlePageLinks={props.handlePageLinks}
					/>
				</div>
				<div className={"account-menu-body"}>
					<div className="account-menu-links">
						<div
							key="profile"
							onClick={() => props.handlePageLinks("/profile")}
						>
							<CustomPageLink
								activeOnlyWhenExact={true}
								to="/myonlyall"
							>
								<FontAwesomeIcon icon={faUser} />
								{t("Pages.MY_SPACE")}
							</CustomPageLink>
						</div>
						<div
							key="settings"
							onClick={() => props.handlePageLinks("/settings")}
						>
							<CustomPageLink
								activeOnlyWhenExact={true}
								to="/settings"
							>
								<FontAwesomeIcon icon={faCog} />
								{t("Pages.MY_SETTINGS")}
							</CustomPageLink>
						</div>
						<div>
							<a
								href="/#disconnect"
								onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
									OnesignalLogout();
									sessionStorage.clear();
									storage.removeItem("token");
									storage.removeItem("account");
									sendLogLogout();
									window.location.assign("/");
								}}
							>
								<FontAwesomeIcon icon={faPowerOff} />
								{t("Accounts.DISCONNECT")}
							</a>
						</div>
						{/* <div className="theme-switch-cont mb-2">
							<SwitchInput
								label={t("Theme.DARK_THEME")}
								checked={
									!cur_theme || cur_theme === "light"
										? false
										: true
								}
								onChange={(elem) => theme.switchTheme(elem)}
							/>
						</div> */}
					</div>
					{accounts.filter((u) => u.EmployesId !== account.EmployesId).length > 0 && (
						<>
							<div
								className="accounts-toggle"
								onClick={() => setAccountsOpen(!accountsOpen)}
							>
								<span>{t("Accounts.OTHER_ACCOUNTS")}</span>
								<FontAwesomeIcon
									icon={faChevronUp}
									className={"accounts-toggle-chevron" + (accountsOpen ? " open" : "")}
								/>
							</div>
							<div className={"accounts-list-collapsible" + (accountsOpen ? " open" : "")}>
								<div className="accounts-list">
									{accounts.map((user, b) => {
										if (user.EmployesId === account.EmployesId)
											return false;
										return (
											<AccountElem
												key={user.EmployesId || "fallback-" + b}
												user={user}
												onClick={() => {
													sessionStorage.clear();
													storage.removeItem("token");
													storage.removeItem("account");
													window.location.assign(
														"/" + user.EmployesId
													);
												}}
											/>
										);
									})}
								</div>
							</div>
						</>
					)}
					<div className="copyrights">
						<a
							href="https://onlyall.fr"
							rel="noreferrer"
							target={"_blank"}
						>
							v{process.env.REACT_APP_VERSION} - OnlyAll
						</a>{" "}
						©{" "}
						<a
							href="https://joonsoft.fr"
							rel="noreferrer"
							target={"_blank"}
						>
							JoonSoft
						</a>
					</div>
				</div>
			</div>
		);
	}

	if (!token) {
		let contAnim = {
			hidden: { opacity: 0 },
			show: {
				opacity: 1,
				transition: {
					when: "beforeChildren",
					staggerChildren: 0.1,
				},
			},
		};

		const itemAnim = {
			hidden: { y: -10, opacity: 0 },
			show: {
				y: 0,
				opacity: 1,
				transition: {
					ease: "easeInOut",
				},
			},
		};

		return (
			<div>
				<motion.div
					variants={contAnim}
					initial="hidden"
					animate="show"
					className={`accounts-list ${
						CurAccount ? "active-cur" : ""
					}`}
				>
					{accounts.map((account) => {
						return (
							<motion.div
								className="account-item-anim"
								variants={itemAnim}
								key={account.EmployesId}
							>
								<Account
									handleRemove={() =>
										handleRemove(account.Login)
									}
									isActive={
										CurAccount?.EmployesId ===
										account.EmployesId
									}
									datas={account}
									onClick={handleClick}
								/>
							</motion.div>
						);
					})}
				</motion.div>
				<div className="text-center" onClick={newAccount}>
					<a href="/#add-account" role="button">
						{t("Accounts.ADD_ACCOUNT")}
					</a>
				</div>
			</div>
		);
	} else return <MultiAccount />;
}

function CurAccountElem({
	user,
	isActive,
	onClick,
	handlePageLinks,
	toggleMenu,
	OnesignalLogout,
}) {
	const storage = new Storage();
	const openProfile = (e) => {
		e.preventDefault();
		e.stopPropagation();
		handlePageLinks("/myonlyall");
	};

	return (
		<div className={"account-menu account-menu-intro"} onClick={onClick}>
			<div className="account-menu-infos w-100">
				<div className="d-flex justify-content-between">
					<div className="w-auto text-intro">
						{t("Commons.WELCOME") + " "}
						{user.FirstName +
							(!isActive ? " " + user.LastName : "")}
					</div>
					{/* <CustomPageLink
						activeOnlyWhenExact={true}
						to="/myonlyall"
						onClick={openProfile}
					>
					</CustomPageLink> */}
				</div>
			</div>
			<div
			// key="myonlyall"
			// onClick={(e) => {
			// 	e.preventDefault();
			// 	e.stopPropagation();
			// 	handlePageLinks("/myonlyall");
			// }}
			>
				{/* <CustomPageLink activeOnlyWhenExact={true} to="/myonlyall"> */}
				<UserImage
					companyId={user.CompanyId}
					employeId={user.EmployesId}
					title={user.FirstName + " " + user.LastName}
				/>
				{/* </CustomPageLink> */}
			</div>
		</div>
	);
}
function AccountElem({ user, isActive, onClick, toggleMenu }) {
	let comp_name = user.Company?.Name;

	return (
		<div
			className={
				"account-menu d-flex align-items-center justify-content-center d-flex gap-2 w-100 cursor-pointer p-1"
			}
			onClick={onClick}
		>
			<UserImage
				companyId={user.CompanyId}
				employeId={user.EmployesId}
				title={user.FirstName + " " + user.LastName}
			/>
			<div className="account-menu-infos w-100">
				<div className="d-flex justify-content-between">
					<div className="w-auto">
						{user.FirstName +
							(!isActive ? " " + user.LastName : "")}
						{comp_name?.length > 0 && (
							<div className="company-name">{comp_name}</div>
						)}
					</div>
					{isActive && (
						<Button
							className="w-auto btn-transp btn-h-bg"
							style={{ fontSize: "12px" }}
							title="Menu du compte"
							onClick={toggleMenu}
						>
							<FontAwesomeIcon icon={faCog} color="grey" />
						</Button>
					)}
				</div>
			</div>
		</div>
	);
}

export default AccountsMenu;
